import { atom } from 'recoil';

export const productSearchState = atom<string>({
  key: 'productSearchState',
  default: ''
});
